module.exports = __webpack_public_path__ + "static/media/71wkJ5I657L._SL1500_.a6639e04.jpg";